<template>
  <div class="allocationDetail">
    <el-form ref="form" v-loading="loading" :model="form" class="baseInfoForm">
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              电汇编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.telegraphicTransferNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              汇入公司：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.accountCompany }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              币种：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.currency }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              客户名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.importCompany }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              汇款日期：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.remittanceDate }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              汇款金额：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.remittanceAmount }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              汇入行：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.importBank }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              汇入账户：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.importAccount }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              状态：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.transferFromName }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              备注：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.summary }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              可用余额
            </div>
            <div class="rj-baseinfo__item">
              {{ form.unusedAmount }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              作废类型 ： <span> {{ form.rebuild }} </span>
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              申请作废理由 ： <span> {{ form. reason }} </span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin:10px">
        审批意见：
      </div>
      <el-table :data="tableData" border>
        <el-table-column prop="approver" label="审批人" align="left" />
        <el-table-column prop="approvalOpinion" label="审批内容" align="left" />
        <el-table-column prop="approvalTime" label="审批时间" align="left" />
        <el-table-column prop="approvalResult" label="是否同意" align="left" />
      </el-table>
    </el-form>
  </div>
</template>

<script>
import { ToInvoiceView } from '@/API';
export default {
  name: 'AllocationDetail',
  data () {
    return {
      form: {},
      tableLoading: false,
      dataList: [],
      causeRevocation: '',
      isErpLoading: false,
      loading: false,
      tableData: []
    };
  },
  mounted () {
    this.initData();
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  methods: {
    initData () {
      this.loading = true;
      ToInvoiceView(this.id).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.form = json.data;
          this.tableData = json.data.telFundManagementApprovalRecords;
        }
      }).catch(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style>

</style>
